

export const nextPage = (page) => {

    const url = new URLSearchParams(window.location.search)
    console.log(url)
    url.delete('page');
    url.append('page', page)
    window.location.search = decodeURI(url.toString()) ;

}